import { FC, memo } from 'react';

import V2GroupsPresenter from './V2GroupsPresenter';

const V2Groups: FC = memo(() => (
  <V2GroupsPresenter />
));

export default V2Groups;
